'use client'
// =============================================================================
// CoreTab — onglet CORE de l'AI Command Center (ex-onglet "AI"). Source
// stricte : Mission Engine + Agent Runtime + EventBus, rien d'autre (voir
// docs/architecture/command-center-ui.md, Modèle mental 4 couches). Remplace
// l'ancien AITab, qui affichait 3 "CANAUX LEGAL AI" codés en dur
// (# zoning-analysis, # municipal-rag, # extraction-jobs) — jamais de canal
// réel derrière, retiré plutôt que reconduit.
// =============================================================================
import { AgentCard } from '../widgets/AgentCard'
import { MissionCard } from '../widgets/MissionCard'
import { EventStream } from '../widgets/EventStream'

export function CoreTab() {
  return (
    <>
      <AgentCard />
      <MissionCard />
      <EventStream />
    </>
  )
}
